export interface Solution {
  id: string;
  problema: string;
  solucion: string;
  icono: string;
}

export const solutions: Solution[] = [
  {
    id: "pagina-web",
    problema: "Necesitas una página web.",
    solucion: "Creamos una presencia digital profesional.",
    icono: "ri-global-line",
  },
  {
    id: "controlar-negocio",
    problema: "Necesitas controlar tu negocio.",
    solucion: "Desarrollamos sistemas empresariales personalizados.",
    icono: "ri-dashboard-3-line",
  },
  {
    id: "controlar-inventario",
    problema: "Necesitas controlar el inventario.",
    solucion: "Creamos sistemas de inventario y operaciones.",
    icono: "ri-archive-line",
  },
  {
    id: "vender-online",
    problema: "Necesitas vender online.",
    solucion: "Creamos catálogos y plataformas comerciales.",
    icono: "ri-shopping-bag-3-line",
  },
  {
    id: "automatizar",
    problema: "Necesitas automatizar procesos.",
    solucion: "Diseñamos automatizaciones e integraciones.",
    icono: "ri-flow-chart",
  },
  {
    id: "aplicacion",
    problema: "Necesitas una aplicación.",
    solucion: "Desarrollamos experiencias web y móviles.",
    icono: "ri-smartphone-line",
  },
  {
    id: "conectar-servicios",
    problema: "Necesitas conectar diferentes servicios.",
    solucion: "Integramos APIs y plataformas externas.",
    icono: "ri-plug-line",
  },
];